import {
  type CustomerDownloadAgreement,
  type ProductDetail,
} from 'types/isomorphic/download.types';

export const resolvePaProjectCodes = (
  agreement: CustomerDownloadAgreement
): Pick<ProductDetail, 'projectCodes' | 'projectCodeRequired'> | null => {
  if (agreement.productType !== 'PremiumAccess') {
    return null;
  }
  const productDetails = agreement.productDetails as unknown as ProductDetail;
  const projectCodes = productDetails?.projectCodes ?? [];
  if (projectCodes.length === 0) {
    return null;
  }
  return {
    projectCodes,
    projectCodeRequired: productDetails?.projectCodeRequired ?? false,
  };
};
